<template lang="pug">
  #member-questions
    BTabs.answer-tabs(
      v-model="activeTab"
      @input="updateRoute(activeTab)"
      size="is-medium"
    )
      BTabItem(v-for="tab in tabs" :key="tab.label" :label="tab.label")
    KeepAlive
      RouterView
</template>

<script>
import WtTile from "@@/WtTile/WtTile";
import WtTitle from "@@/WtTitle/WtTitle";
import MemberQuestionsUnanswered from "./MemberQuestionsUnanswered";
import MemberQuestionsAnswered from "./MemberQuestionsAnswered";
import { tabsMixin } from "../mixins/tabsMixin";

export default {
  name: "MemberQuestions",

  components: {
    WtTile,
    WtTitle,
    MemberQuestionsUnanswered,
    MemberQuestionsAnswered
  },

  mixins: [tabsMixin],

  data() {
    return {
      tabs: [
        {
          label: "Unanswered",
          routeName: "MemberQuestionsUnanswered"
        },
        {
          label: "Answered",
          routeName: "MemberQuestionsAnswered"
        }
      ]
    };
  }
};
</script>

<style lang="sass" scoped>
#member-questions
  background-color: white
  border-radius: 20px
.answer-tabs
  font-weight: 500
  font-size: 14px
  line-height: 20px
  letter-spacing: 0px
  min-height: 46px
/deep/ .answer-tabs .tabs
  display: flex

/deep/ .answer-tabs .tabs ul
  display: flex
  width: 100%
  max-width: 100%

/deep/ .answer-tabs .tabs ul li
  flex: 1
  text-align: center
/deep/ .answer-tabs .tabs li a
  min-height: 46px
</style>
